import { PURGE } from 'redux-persist';

// Default Sales AI branding
const defaultBranding = {
  logo: null,
  favicon: '',
  agencyName: 'Loading...',
  primaryColor: '#541530',
  secondaryColor: '#FBFBFF',

  emailLogo: null,
  emailFooter: 'Loading...'
};

const initialState = {
  members: [],
  apiKeys: [],
  workspaces: [],
  userDetails: {},
  pendingInvites: [],
  apiKeyCreated: null,
  currentWorkspace: {},
  newWorkspaceModal: false,
  currentSubscription: {},
  domainBranding: null,
  isCustomBranding: false,
  currentBranding: defaultBranding,
  brandingLoaded: false,

  isLoading: false,
  isCtrlPressed: false,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case PURGE:
      return initialState;

    case 'SET_MEMBERS':
      return { ...state, members: payload };

    case 'SET_USER_DETAILS':
      if (payload['user']) { localStorage.setItem('user', JSON.stringify(payload['user'])); }
      return {
        ...state,
        userDetails: payload,
        workspaces: payload['workspaces'] || state['workspaces'],
        currentWorkspace: payload['workspace'] || state['currentWorkspace'],
        currentSubscription: payload['workspace']?.['currentSubscription'] || state['currentSubscription']
      }

    case 'UPDATE_CURRENT_SUBSCRIPTION':
      return { ...state, currentSubscription: payload}

    case 'SET_DOMAIN_BRANDING':
      const isCustom = payload?.['isCustom'] || false;
      return {
        ...state,
        domainBranding: payload,
        currentBranding: payload,
        isCustomBranding: isCustom,
        brandingLoaded: true
      }

    case 'SET_BRANDING_LOADED':
      return { ...state, brandingLoaded: true }

    case 'SET_UPDATE_WORKSPACE':
      return { ...state, currentWorkspace: payload }

    case 'SET_PENDING_INVITES':
      return { ...state, pendingInvites: payload }

    case 'GET_API_KEYS':
      return { ...state, isLoading: true }

    case 'SET_API_KEYS':
      return { ...state, apiKeys: payload, isLoading: false }

    case 'LOGOUT':
      return {
        ...initialState,
        currentBranding: state.currentBranding,
        isCustomBranding: state.isCustomBranding,
        domainBranding: state.domainBranding
      };

    case 'SET_API_KEY_CREATED':
      return { ...state, apiKeyCreated: payload }

    case 'SET_NEW_WORKSPACE_MODAL':
      return { ...state, newWorkspaceModal: payload }

    case 'SET_CTRL_PRESSED':
      return { ...state, isCtrlPressed: payload }

    default:
      return state;
  }
}